import request from '@/router/axios';
//获取光伏-储能总收益、煤炭树
export const searchSolarAndEnergyStorageIncomeAndSaveEmissions = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchSolarAndEnergyStorageIncomeAndSaveEmissions',
    method: 'post',
    data: data
  })
}
//获取光伏总容量与储能总容量
export const searchSolarAndEnergyStorageVolume = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchSolarAndEnergyStorageVolume',
    method: 'post',
    data: data
  })
}
//充放电量统计
export const searchChargeAndDischargeStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchChargeAndDischargeStatistics',
    method: 'post',
    data: data
  })
}

//安全运行天数统计
export const searchEnergyStorageSafeOperationDays = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchEnergyStorageSafeOperationDays',
    method: 'post',
    data: data
  })
}

//日充放电量统计-柱状图
export const searchEnergyStorageChargeAndDischargeColumnChart = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchEnergyStorageChargeAndDischargeColumnChart',
    method: 'post',
    data: data
  })
}
//收益统计-柱状图
export const searchEnergyStorageIncomeStatisticsColumnChart = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchEnergyStorageIncomeStatisticsColumnChart',
    method: 'post',
    data: data
  })
}

//储能总容量-投运纵容量
export const searchEnergyStorageCommissioningAndEnergyStorageVolume = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchEnergyStorageCommissioningAndEnergyStorageVolume',
    method: 'post',
    data: data
  })
}

//光伏统计
export const searchSolarStatistics = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchSolarStatistics',
    method: 'post',
    data: data
  })
}

//组织首页节能统计
export const searchGroupEnergySaveStatistics = () => {
  return request({
    url: '/svolt-ess-service/groupMain/searchGroupEnergySaveStatistics',
    method: 'get'
  })
}

//组织首页统计容量
export const searchStatisticalCapacityByGroup = () => {
  return request({
    url: '/svolt-ess-service/groupMain/searchStatisticalCapacityByGroup',
    method: 'get'
  })
}

//组织首页统计容量详情
export const statisticalCapacityByGroupDetail = () => {
  return request({
    url: '/svolt-ess-service/groupMain/statisticalCapacityByGroupDetail',
    method: 'get'
  })
}

//组织首页树状项目列表
export const searchProjectTreeListByGroupId = (data) => {
  return request({
    url: '/svolt-ess-service/groupMain/searchProjectTreeListByGroupId',
    method: 'get',
    params: data
  })
}

//组织首页收益统计
export const searchGroupEarningsStatistics = () => {
  return request({
    url: '/svolt-ess-service/groupMain/searchGroupEarningsStatistics',
    method: 'get'
  })
}

//组织首页收益统计详情
export const groupEarningsStatisticsDetail = () => {
  return request({
    url: '/svolt-ess-service/groupMain/groupEarningsStatisticsDetail',
    method: 'get'
  })
}

//组织首页电量统计
export const searchElectricityStatistics = () => {
  return request({
    url: '/svolt-ess-service/groupMain/searchElectricityStatistics',
    method: 'get'
  })
}

//组织首页电量统计详情
export const electricityStatisticsDetail = () => {
  return request({
    url: '/svolt-ess-service/groupMain/electricityStatisticsDetail',
    method: 'get'
  })
}

export default {
  searchSolarAndEnergyStorageIncomeAndSaveEmissions,
  searchSolarAndEnergyStorageVolume,
  searchChargeAndDischargeStatistics,
  searchEnergyStorageSafeOperationDays,
  searchEnergyStorageChargeAndDischargeColumnChart,
  searchEnergyStorageIncomeStatisticsColumnChart,
  searchEnergyStorageCommissioningAndEnergyStorageVolume,
  searchSolarStatistics,
  searchGroupEnergySaveStatistics,
  searchStatisticalCapacityByGroup,
  statisticalCapacityByGroupDetail,
  searchProjectTreeListByGroupId,
  searchGroupEarningsStatistics,
  groupEarningsStatisticsDetail,
  searchElectricityStatistics,
  electricityStatisticsDetail
}



// WEBPACK FOOTER //
// ./src/api/svolt/home.js